import { Card, CardContent } from '@/components/ui/card';
import { TrendingDown, TrendingUp, DollarSign, Receipt } from 'lucide-react';

const fmt = (v) =>
  '$' + Math.abs(v).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function StatsCards({ transactions }) {
  const debits = transactions.filter(t => t.type === 'debit');
  const credits = transactions.filter(t => t.type === 'credit');
  const totalExpenses = debits.reduce((s, t) => s + (t.amount || 0), 0);
  const totalIncome = credits.reduce((s, t) => s + (t.amount || 0), 0);
  const net = totalIncome - totalExpenses;

  const stats = [
    { title: 'Total Expenses', value: fmt(totalExpenses), icon: TrendingDown, color: 'text-rose-600', bg: 'bg-rose-50' },
    { title: 'Total Income', value: fmt(totalIncome), icon: TrendingUp, color: 'text-emerald-600', bg: 'bg-emerald-50' },
    {
      title: 'Net Balance',
      value: (net < 0 ? '-' : '') + fmt(net),
      icon: DollarSign,
      color: net >= 0 ? 'text-emerald-600' : 'text-rose-600',
      bg: net >= 0 ? 'bg-emerald-50' : 'bg-rose-50',
    },
    { title: 'Transactions', value: transactions.length.toLocaleString(), icon: Receipt, color: 'text-blue-600', bg: 'bg-blue-50' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <Card key={s.title} className="border-0 shadow-sm bg-white">
          <CardContent className="p-5">
            <div className="flex items-center justify-between mb-3">
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{s.title}</p>
              <div className={`p-1.5 rounded-lg ${s.bg}`}>
                <s.icon className={`w-3.5 h-3.5 ${s.color}`} />
              </div>
            </div>
            <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}